import { render, staticRenderFns } from "./MenuFinancial.vue?vue&type=template&id=670bd17f&"
import script from "./MenuFinancial.vue?vue&type=script&lang=js&"
export * from "./MenuFinancial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports